import { SxProps, Theme } from '@mui/material';

export const taskDrawerViewStyles = {
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    py: 2,
  },

  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  tableContainer: {
    pt: 1,
  },

  stepCellContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  stepMetaBox: {
    display: 'flex',
    flexDirection: 'column',
  },

  emptyState: {
    textAlign: 'center',
  },
};

export const getStepButtonStyles = ({
  active,
  activeColor,
  inactiveBorder = '#E3E3E5',
  activeBg,
}: {
  active: boolean;
  activeColor: string;
  inactiveBorder?: string;
  activeBg?: string;
}): SxProps<Theme> => ({
  border: '1px solid',
  borderColor: active ? activeColor : inactiveBorder,
  bgcolor: active ? activeBg || `${activeColor}15` : '#fff',
  borderRadius: '6px',
  width: 36,
  height: 36,
  cursor: 'pointer',
});
